<template>
  <div class="p-4 h-full max-h-screen sticky top-0">
    <div
      class="gradient rounded-lg bg-neutral-100 h-full overflow-hidden w-full relative"
      style="clip-path: polygon(0px 0px, 0px 100%, 100% 100%, 100% 0)"
    >
      <svg
        class="absolute top-0 left-0 right-0 pointer-events-none -z-0"
        xmlns="http://www.w3.org/2000/svg"
        width="524"
        height="781"
        viewBox="0 0 524 781"
        fill="none"
      >
        <path
          d="M48.0061 736.244L48.0061 734.157C48.0565 722.118 50.4788 710.208 55.1346 699.105C59.7904 688.003 66.5884 677.927 75.14 669.453L146.106 590.139L164.891 569.267L183.676 548.394L484.236 208.177C509.642 180.159 523.77 143.724 523.893 105.903L523.893 -127.866C524.238 -136.961 523.537 -146.065 521.806 -155C510.856 -131.657 496.816 -109.894 480.061 -90.296L411.183 -10.9815L396.572 5.71623L381.962 22.414L22.9594 427.335C18.785 433.597 14.6106 441.946 10.4361 448.208C3.79267 462.618 0.237807 478.26 -1.24993e-05 494.127L-3.83189e-06 692.413C0.053538 703.831 2.17501 715.146 6.26167 725.808C16.1225 749.874 34.7814 769.28 58.4423 780.076C56.127 776.269 54.7002 771.988 54.2678 767.553C50.1859 757.617 48.0598 746.986 48.0061 736.244Z"
          fill="white"
          fill-opacity="0.4"
        />
      </svg>
      <div class="max-w-md pt-14 pl-11 lg:pl-20 xl:pl-24 pr-6 relative z-1">
        <h3 class="gradient-text text-2xl font-bold">
          Con Mobius podrás aprender de una manera diferente
        </h3>
        <p class="text-[#A79898] mt-5">
          Disfruta de un aprendizaje personalizado y alcanza tu maximo potencial
        </p>
      </div>
      <img
        class="mt-10 ml-auto w-full max-w-[90%] relative z-1"
        src="/images/platform-overview-register.png"
        alt=""
      />
      <div
        class="gradient-white absolute left-0 right-0 bottom-0 pointer-events-none h-[40%]"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterBanner",
};
</script>

<style>
.gradient {
  background: linear-gradient(
    180deg,
    #ccdaff 0%,
    #ededed 28.29%,
    #faefec 60.51%
  );
}

.gradient-text {
  background: linear-gradient(160deg, #8f8de4 0%, #e98798 58.81%, #fac6c4 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-white {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 58.3%);
}
</style>
